import { motion } from 'framer-motion';
import Reveal from '@/components/common/Reveal';
import { process as steps } from '@/data/projects';

export const ProcessSection = () => (
  <section id="process" className="py-24 md:py-32">
    <div className="mx-auto container-editorial">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 mb-16">
        <Reveal className="lg:col-span-7">
          <div className="label-eyebrow mb-4">Chapter — Process</div>
          <h2 className="font-serif text-4xl md:text-6xl lg:text-7xl leading-[0.95] tracking-tight text-balance">
            Six chapters, <span className="italic-serif text-sienna">not six sprints.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.15} className="lg:col-span-5 lg:pt-6">
          <p className="text-base md:text-lg text-muted-foreground leading-relaxed">
            We treat a website like an editorial project — each phase has a name,
            a purpose, and a written artefact you can hold. No agile theatre. No
            invisible progress.
          </p>
        </Reveal>
      </div>

      <div className="relative">
        <div className="absolute left-4 md:left-10 top-4 bottom-4 w-px bg-border" aria-hidden />
        <ul className="space-y-14 md:space-y-20">
          {steps.map((s, i) => (
            <motion.li
              key={s.n}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-80px' }}
              transition={{ delay: i * 0.05, duration: 0.7 }}
              className="grid grid-cols-12 gap-4 md:gap-8 relative"
            >
              <div className="col-span-2 md:col-span-1 relative">
                <span className="relative z-10 inline-flex w-8 h-8 md:w-10 md:h-10 rounded-full bg-background border border-border items-center justify-center font-serif text-sm">
                  {s.n}
                </span>
              </div>
              <div className="col-span-10 md:col-span-5">
                <h3 className="font-serif text-3xl md:text-5xl tracking-tight leading-[0.98]">
                  {s.title}
                </h3>
              </div>
              <div className="col-span-12 md:col-span-6">
                <p className="text-base md:text-lg text-muted-foreground leading-relaxed max-w-xl">
                  {s.lede}
                </p>
                <div className="mt-4 flex items-center gap-3 label-eyebrow">
                  <span className="w-6 h-px bg-sienna" />
                  Chapter {s.n}
                </div>
              </div>
            </motion.li>
          ))}
        </ul>
      </div>
    </div>
  </section>
);

export default ProcessSection;
